export const personNameFilter = /[^a-zA-ZÀ-ÖØ-öø-ÿĀ-ž- ]/g
export const phoneForValidation =
  /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/
export const regExpEmailFilter = /([^\w_+&*-.@])+/g
export const regExpEmailCheck =
  /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/
// eslint-disable-next-line
export const phoneFilter = /[^\d\+\-()]+/g
export const postCodeFilter = /[^\d\- ]+/g
export const identificationCodeFilter = /[^\d]+/g
export const amountFilter = /[^\d+.{0,3}$]+/g
export const ibanRegex = /[^A-Za-z0-9 ]/g
export const swiftRegex = /[[A-Za-z0-9 ]]/g
export const accountRegex = /^0-9 ]/g
